export const ANGLE_ORDER = ['Front', 'Back', 'Left', 'Right', 'Bottom', 'Detail'];

const ANGLE_PATTERNS = [
  { label: 'Front', pattern: /front|_fr\b|face|main|cover/i },
  { label: 'Back', pattern: /back|_bk\b|rear/i },
  { label: 'Left', pattern: /left|_lt\b|side.?l/i },
  { label: 'Right', pattern: /right|_rt\b|side.?r/i },
  { label: 'Bottom', pattern: /bottom|_bt\b|under|brim/i },
  { label: 'Detail', pattern: /detail|close.?up|tag|sticker|logo|patch/i }
];

export function detectAngleFromUrl(url, index = 0) {
  const filename = decodeURIComponent(String(url || ''))
    .split('/')
    .pop()
    ?.replace(/\.[a-z0-9]+$/i, '') || '';

  for (const { label, pattern } of ANGLE_PATTERNS) {
    if (pattern.test(filename)) {
      return label;
    }
  }

  if (index === 0) {
    return 'Front';
  }

  if (index < ANGLE_ORDER.length) {
    return ANGLE_ORDER[index];
  }

  return `Angle ${index + 1}`;
}

export function angleIndex(label) {
  const index = ANGLE_ORDER.indexOf(label);

  return index === -1 ? ANGLE_ORDER.length : index;
}
